// Blog Configuration
export const blogConfig = {
    postsPerPage: 6,
    showReadTime: true,
    enableComments: false,
    categories: ["devlog", "tutorial", "personal", "tech", "projects"],
    defaultThumbnail: "/images/blog/default.png",
    author: {
        name: "Puppy-Z4nx",
        avatar: "/images/avatar.png",
    },
};

const blogPosts = [
    {
        id: "hello-world",
        title: "Hello World!: My first blog post",
        description: "Welcome to my devlog! Here, I will share my journey of exploring web development.",
        date: "2026-01-18",
        tags: ["general", "intro"],
        filename: "hello-world.md",
        thumbnail: "/images/blog/",
        readTime: "2 min",
        author: "Puppy-Z4nx",
        featured: true,
        category: "personal",
    },
    {
        id: "project-puppy-z4nx",
        title: "Building Puppy-Z4nx: Tech stack breakdown",
        description: "Deep dive into the modern web technologies used to build this personal portfolio website.",
        date: "2026-01-18",
        tags: ["react", "frontend", "devlog"],
        filename: "project-puppy-z4nx.md",
        thumbnail: "/images/blog/",
        readTime: "5 min",
        author: "Puppy-Z4nx",
        featured: true,
        category: "devlog",
    },
    {
        id: "discord-bot-journey",
        title: "My Discord Bot Journey",
        description: "From JavaScript to TypeScript — building a feature-rich Discord bot.",
        date: "2026-01-17",
        tags: ["discord", "typescript", "nodejs"],
        filename: "discord-bot-journey.md",
        thumbnail: "/images/blog/",
        readTime: "8 min",
        author: "Puppy-Z4nx",
        featured: true,
        category: "projects",
    },
    {
        id: "spotify-integration",
        title: "Integrating Spotify into my portfolio",
        description: "How I built a custom Spotify visualizer and music player.",
        date: "2026-01-16",
        tags: ["spotify", "api", "frontend"],
        filename: "spotify-integration.md",
        thumbnail: "/images/blog/",
        readTime: "6 min",
        author: "Puppy-Z4nx",
        featured: false,
        category: "devlog",
    },
    {
        id: "react-hooks-tips",
        title: "React Hooks Tips",
        description: "Core patterns and best practices of React Hooks every developer should master.",
        date: "2026-01-15",
        tags: ["react", "hooks", "tutorial"],
        filename: "react-hooks-tips.md",
        thumbnail: "/images/blog/",
        readTime: "7 min",
        author: "Puppy-Z4nx",
        featured: false,
        category: "tutorial",
    },
    {
        id: "seo-best-practices",
        title: "SEO Best Practices for Personal Websites",
        description: "A comprehensive guide to optimizing personal portfolio websites for search engines.",
        date: "2026-01-14",
        tags: ["seo", "web", "marketing"],
        filename: "seo-best-practices.md",
        thumbnail: "/images/blog/",
        readTime: "10 min",
        author: "Puppy-Z4nx",
        featured: false,
        category: "tutorial",
    },
];

export default blogPosts;
